var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M350,0C156.8,0,0,156.8,0,350s156.8,350,350,350s350-156.8,350-350C700,156.8,543.2,0,350,0L350,0z M350,627.9 C196.7,627.9,72.1,503.3,72.1,350C72.1,196.7,196.7,72.1,350,72.1c153.3,0,277.9,124.6,277.9,277.9 C627.9,503.3,503.3,627.9,350,627.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.6,250.5c0,24.6-19.9,44.5-44.5,44.5c-24.6,0-44.5-19.9-44.5-44.5S238.5,206,263,206 C287.6,206,307.6,225.9,307.6,250.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.5,250.5c0,24.6-19.9,44.5-44.5,44.5c-24.6,0-44.5-19.9-44.5-44.5S410.4,206,435,206 C459.6,206,479.5,225.9,479.5,250.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.5,419c-32.7,18.1-72.4,29.2-115.5,29.2c-43.1,0-83.5-11.1-115.5-29.2c-13.9-7.7-32.7-5.6-43.1,4.9 c-10.4,10.4-7,25.1,6.3,32.7C238,480.2,291,494.8,348,494.8c57.1,0,109.9-14.6,152.4-38.3c13.9-7.7,16.7-22.3,6.3-32.7 C496.2,413.4,477.4,411.3,463.5,419L463.5,419z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGood);
export default __webpack_public_path__ + "static/media/good.1b61428ba8375661c524acd59649d128.svg";
export { ForwardRef as ReactComponent };